import { render, staticRenderFns } from "./lbXq.vue?vue&type=template&id=489b3c49&scoped=true"
import script from "./lbXq.vue?vue&type=script&lang=js"
export * from "./lbXq.vue?vue&type=script&lang=js"
import style0 from "./lbXq.vue?vue&type=style&index=0&id=489b3c49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489b3c49",
  null
  
)

export default component.exports